<template>
  <Modal
    v-model="showModelchild"
    class-name="messagedetail"
    @on-cancel="closeModel"
    :mask-closable="false"
    :closable="false"
    width="450px"
  >
    <div class="iconbutton" slot="header">
      <p>消息</p>
    </div>
    <div class="contentstyle">
      <h4>{{noticeName || ""}}</h4>
      <!-- <p>{{detailmessage}}</p> -->
      <div v-html="detailmessage"></div>
    </div>
    <div slot="footer">
      <Button type="default" size="small" @click="closeModel">知道了</Button>
    </div>
  </Modal>
</template>
<script>
import { mapActions } from "vuex";
import { GETMESSAGEDATE } from "@/store/readmessage";
export default {
  data() {
    return {
      showModelchild: false,
      iswatchopened: 0,
    };
  },

  props: [
    "detailmessage",
    "noticeId",
    "noticeName",
    "noticeIsRead",
    "noticeIsAlert",
    'dataTableShow'
  ],
  watch: {
    showModelchild: function () {
      var isRead = this.noticeIsRead;
      if (isRead == 1) {
        return;
      }
      if (this.showModelchild == true && this.iswatchopened == 0) {
        // 更新当前状态
        var id = this.noticeId;
        var isAlert = this.noticeIsAlert;
        var params = {id, isRead, isAlert}
        this.$api.platIndex.messageRead(params).then((res) => {
          const { result, infos } = res.data;
          if (result != "success") {
            this.$Message.warning(infos);
          }
        });
      }
    },
  },
  methods: {
    ...mapActions(["GETMESSAGEDATE"]),

    closeModel() {
      this.showModelchild = false;
      this.GETMESSAGEDATE();
      if (this.dataTableShow) {
        this.dataTableShow('pagejump');
      }
    },
  },
};
</script>
<style lang="scss">
.messagedetail {
  //  .ivu-modal-footer {
  // border-top: 1px solid #e8eaec;
  // padding: 12px 18px 12px 18px;
  // text-align: center;
  // }
  .ivu-btn {
    border-radius: 5px;
    padding: 0px 15px;
    span {
      font-size: 12px;
    }
  }
  // 弹框颜色
  .ivu-modal-header {
    border-bottom: 1px solid #e8eaec;
    padding: 6px 16px;
    line-height: 1;
    p {
      display: inline-block;
      width: 100%;
      line-height: 20px;
      font-size: 14px;
      color: #17233d;
      font-weight: 700;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-top: 5px;
    }
  }
  .contentstyle {
    word-break: break-all;
    h4 {
      font-size: 15px;
      font-weight: 900;
      color: #515a6e;
      margin-bottom: 10px;
    }
    div {
      height: 160px;
      line-height: 20px;
      overflow-y: auto;
    }
  }

  .iconbutton {
    span {
      position: absolute;
      top: 18px;
      right: 40px;
      &:nth-child(2) {
        right: 65px;
      }
    }
  }
}
</style>

